import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { INotifier } from './notifier.interface';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class NotifierService {
  // Source
  private notifierSource = new Subject<INotifier>();
  private systemNotifierSource = new Subject<INotifier>();
  private behaviorNotifierSource = new BehaviorSubject<INotifier>({});
  private userMgmtSource = new BehaviorSubject<any>({});

  // Stream
  notifierObject$ = this.notifierSource.asObservable();
  behaviorNotifierObject$ = this.behaviorNotifierSource.asObservable();
  systemMessagesNotifierObject$ = this.systemNotifierSource.asObservable();
  userMgmtObject$ = this.userMgmtSource.asObservable();

  // Set
  notify(data: INotifier) {
    this.notifierSource.next(data);
  }

  behaviorNotify(data: INotifier) {
    this.behaviorNotifierSource.next(data);
  }

  systemNotify(data: INotifier) {
    this.systemNotifierSource.next(data);
  }

  userMgmtNotify(data) {
    this.userMgmtSource.next(data);
  }

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/system/shared/notifier/notifier.service.ts